<template>
  <div class="list-view product-checkout mt-0">
    <b-skeleton width="100%" height="300px" v-if="loading"></b-skeleton>
    <invoice-detail-item :items="invoice.items.items" v-else />

    <!-- Checkout Options -->
    <div class="checkout-options">
      <b-skeleton width="100%" height="300px" v-if="loading"></b-skeleton>
      <b-card v-else>
        <h6 class="mb-1">مشخصات فروشنده</h6>
        <h4>آکادمی امیر امینی</h4>
        <h6 class="mb-1 mt-2">مشخصات خریدار</h6>
        <h4>{{ userData.first_name + " " + userData.last_name }}</h4>
        <hr />

        <div class="price-details">
          <h6 class="price-title">جمع تخفیف :</h6>
          <ul class="list-unstyled">
            <li class="price-detail">
              <div class="detail-amt">
                {{ Number(invoice.amount) - invoice.final_amount }} تومان
              </div>
            </li>
          </ul>
          <hr />
          <ul class="list-unstyled">
            <li class="price-detail">
              <div class="detail-title detail-total">جمع مبلغ :</div>
              <div class="detail-amt font-weight-bolder">
                {{ invoice.final_amount }} تومان
              </div>
            </li>
          </ul>
          <b-button
            variant="primary"
            block
            @click="order"
            v-if="invoice.status == 0"
          >
            نهایی کردن خرید
          </b-button>
        </div>
      </b-card>
    </div>
    <loader :loading="loader" />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BSkeleton,
} from "bootstrap-vue";
import InvoiceDetailItem from "../invoice-detail/InvoiceDetailItem.vue";
import Loader from "@core/components/loader/Loader.vue";

export default {
  components: {
    InvoiceDetailItem,
    BButton,
    BCard,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BSkeleton,
    Loader,
  },
  data() {
    return {
      loading: false,
      invoice: {},
      items: [],
      loader: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData;
    },
  },
  methods: {
    async order() {
      this.$bvModal
        .msgBoxConfirm("آیا از خرید خود اطمینان دارید؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loader = true;
            this.$http
              .post(`/panel/invoices/${this.$route.query.invoice_id}/purchase`)
              .then((res) => {
                const { data } = res;
                if (data.data.method == "GET") {
                  location.replace(data.data.action);
                  // this.$http.get(data.data.action, {
                  //   params: {
                  //     inputs: data.data.input,
                  //   },
                  // }).then(res=>{
                  // });
                } else {
                  this.$http.post(data.data.action, {
                    inputs: data.data.input,
                  });
                }
                //     this.$http[method](
                //   action
                // )
                this.loader = false;
              })
              .catch((err) => {
                this.loader = false;
              });
          }
        });
    },
    async getInvoice() {
      try {
        const { data } = await this.$http.get(
          `/panel/invoices/${this.$route.query.invoice_id}?includes[]=items.model.exercise&includes[]=items.model.session&includes[]=items.model.course`
        );
        this.invoice = data.data;
        this.items = data.data.items.items;
      } catch (err) {}
    },
    // async getItems() {
    //   await this.items.forEach(async (item, index) => {
    //     const {data} = await this.$http.get(
    //         `/panel/${
    //             item.model_type.includes("semester")
    //                 ? "semesters"
    //                 : item.model_type.includes("penalty")
    //                     ? "penalties"
    //                     : "courses"
    //         }/${item.model_id}`
    //     );
    //     this.items[index] = await {...item, ...data.data};
    //   });
    // },
  },
  async created() {
    this.loading = true;
    await this.getInvoice();
    // await this.getItems();
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
};
</script>
